export enum SnackbarType {
    Success = "success",
    SuccessOrangeBackground = "successOrangeBackground",
    Error = "Error",
    Warning = "warning",
}

export interface SnackbarContent {
    type: SnackbarType;
    message: string;
    timeout?: number;
}

export interface Snackbar extends SnackbarContent {
    id: string;
}
